import { render, staticRenderFns } from "./user-files-project-hours.vue?vue&type=template&id=124ddd3e&scoped=true&"
import script from "./user-files-project-hours.vue?vue&type=script&lang=js&"
export * from "./user-files-project-hours.vue?vue&type=script&lang=js&"
import style0 from "./user-files-project-hours.vue?vue&type=style&index=0&id=124ddd3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124ddd3e",
  null
  
)

export default component.exports